import * as types from '../mutation-types';

// state
export const state = {
  message: null,
  type: null,
  visible: null,
};

// getters
export const getters = {
  message: (state) => state.message,
  type: (state) => state.type,
  visible: (state) => state.visible,
};

// mutations
export const mutations = {
  [types.SHOW_NOTIFICATION](state, { message, type }) {
    state.message = message;
    state.type = type;
    state.visible = true;
  },
  [types.HIDE_NOTIFICATION](state) {
    state.visible = false;
  },
};

// actions
export const actions = {
  show({ commit }, payload) {
    if (window.snackbarTimeout) {
      clearTimeout(window.snackbarTimeout);
      window.snackbarTimeout = null;
    }
    commit(types.SHOW_NOTIFICATION, payload);
    window.snackbarTimeout = setTimeout(() => {
      commit(types.HIDE_NOTIFICATION);
    }, 6000);
  },
};
